import { useEffect } from 'react';

import { incrementBlogView } from '#features/blog/model/blog';
import { claimBlogView } from '#features/blog/utils/viewTracker';

/**
 * Counts one view of the given blog post, once, after hydration.
 *
 * Runs in an effect so it never fires during SSR (which also serves crawlers and prefetches).
 * `claimBlogView` makes it at most once per post id per page load, which covers both React 19
 * StrictMode's double effect invocation and re-renders. The request is fire-and-forget:
 * `incrementBlogView` never rejects, so rendering the article cannot fail because of it.
 */
export const useTrackBlogView = (postId: string | null | undefined): void => {
  useEffect(() => {
    if (!postId || !claimBlogView(postId)) {
      return;
    }

    void incrementBlogView(postId);
  }, [postId]);
};
